/* js/components/Header.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Hamburger from './Hamburger.svelte';
import Menu from './Menu.svelte';
import { appRouter } from '../appRouter.js';
import { onMount } from 'svelte';

function create_if_block(ctx) {
	let div1;
	let div0;
	let img;
	let img_src_value;
	let mounted;
	let dispose;

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = appRouter.normalizePath('/_icons/fi-ss-arrow-small-left3.svg'))) attr(img, "src", img_src_value);
			attr(img, "class", "svelte-1hf1sqt");
			attr(div0, "class", "icon-container svelte-1hf1sqt");
			attr(div1, "class", "fab-button top-left");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div0, img);

			if (!mounted) {
				dispose = listen(img, "click", /*onBackRequest*/ ctx[3]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div1);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let menu;
	let t0;
	let div3;
	let div0;
	let p;
	let t1;
	let t2;
	let t3;
	let div2;
	let div1;
	let hamburger;
	let current;
	menu = new Menu({ props: { open: /*navIsOpen*/ ctx[2] } });
	menu.$on("click", /*onBurgerNavClose*/ ctx[5]);
	let if_block = /*backButtonIsvisible*/ ctx[0] && create_if_block(ctx);
	hamburger = new Hamburger({ props: { open: /*navIsOpen*/ ctx[2] } });
	hamburger.$on("click", /*onBurgerSelection*/ ctx[4]);

	return {
		c() {
			create_component(menu.$$.fragment);
			t0 = space();
			div3 = element("div");
			div0 = element("div");
			p = element("p");
			t1 = text(/*title*/ ctx[1]);
			t2 = space();
			if (if_block) if_block.c();
			t3 = space();
			div2 = element("div");
			div1 = element("div");
			create_component(hamburger.$$.fragment);
			attr(div0, "class", "headerlabel top-centered");
			attr(div1, "class", "icon-container svelte-1hf1sqt");
			attr(div2, "class", "fab-button top-right");
			attr(div3, "class", "header box-shadow");
		},
		m(target, anchor) {
			mount_component(menu, target, anchor);
			insert(target, t0, anchor);
			insert(target, div3, anchor);
			append(div3, div0);
			append(div0, p);
			append(p, t1);
			append(div3, t2);
			if (if_block) if_block.m(div3, null);
			append(div3, t3);
			append(div3, div2);
			append(div2, div1);
			mount_component(hamburger, div1, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const menu_changes = {};
			if (dirty & /*navIsOpen*/ 4) menu_changes.open = /*navIsOpen*/ ctx[2];
			menu.$set(menu_changes);
			if (!current || dirty & /*title*/ 2) set_data(t1, /*title*/ ctx[1]);

			if (/*backButtonIsvisible*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div3, t3);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			const hamburger_changes = {};
			if (dirty & /*navIsOpen*/ 4) hamburger_changes.open = /*navIsOpen*/ ctx[2];
			hamburger.$set(hamburger_changes);
		},
		i(local) {
			if (current) return;
			transition_in(menu.$$.fragment, local);
			transition_in(hamburger.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(menu.$$.fragment, local);
			transition_out(hamburger.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(menu, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div3);
			if (if_block) if_block.d();
			destroy_component(hamburger);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { backButtonIsvisible = false } = $$props;
	let { title = "" } = $$props;
	let navIsOpen = false;

	onMount(() => {
		$$invalidate(0, backButtonIsvisible = appRouter.shouldShowBack());
	});

	function onBackRequest() {
		appRouter.back();
	}

	function onBurgerSelection(e) {
		$$invalidate(2, navIsOpen = e.detail.isOpen);
	}

	function onBurgerNavClose() {
		$$invalidate(2, navIsOpen = false);
	}

	$$self.$$set = $$props => {
		if ('backButtonIsvisible' in $$props) $$invalidate(0, backButtonIsvisible = $$props.backButtonIsvisible);
		if ('title' in $$props) $$invalidate(1, title = $$props.title);
	};

	return [
		backButtonIsvisible,
		title,
		navIsOpen,
		onBackRequest,
		onBurgerSelection,
		onBurgerNavClose
	];
}

class Header extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { backButtonIsvisible: 0, title: 1 });
	}
}

export default Header;